import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getToken, getUserId } from '@/utils/auth'

const service = axios.create({
    baseURL: '/v', // url = base url + request url
    timeout: 5000000 // request timeout
})

service.interceptors.request.use(config => {
    var token = store.getters.token
    if(token){
        config.headers.accessToken = getToken()
        config.headers.userId = getUserId()
    }
    return config
},error => {
    console.log(error)
    return Promise.reject(error)
})


service.interceptors.response.use(response => {
    const {data : res} = response
    if(!res.success){
        if(res.code === 505 || res.code === 405){
            store.dispatch('user/resetToken')
            router.push('/login')
        }
        return Promise.reject(new Error(res.msg || 'Error'))
    }else{
        return res
    }
},error => {
    console.log('err' + error)
    return Promise.reject(error)
})

export default service